import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Link, Stack, Typography } from '@mui/joy';
import { TFunction } from 'i18next';
import ViewBase from '../../views/view-base';

interface ViewProps {
  t: TFunction;
  instantLinkAuthURL: string | null;
  onResendClick: VoidFunction;
}

function View(props: ViewProps): JSX.Element {
  const { t, instantLinkAuthURL, onResendClick } = props;

  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  useEffect(() => {
    const initialCooldownTimeout = setTimeout(() => {
      setIsButtonEnabled(true);
    }, 20000); // initial second cooldown

    return (): void => {
      clearTimeout(initialCooldownTimeout);
    };
  }, []);

  useEffect(() => {
    const cooldownTimeout = setTimeout(() => {
      setIsButtonEnabled(true);
    }, 20000); // seconds in milliseconds

    return (): void => {
      clearTimeout(cooldownTimeout);
    };
  }, [isButtonEnabled]);

  const handleClick = (): void => {
    setIsButtonEnabled(false);
    onResendClick();
  };

  return (
    <ViewBase headerText={t('claim.prove.link.title')} prefix="prove" topOffset="0px">
      <Typography textAlign="center">{t('claim.prove.link.sub_title')}</Typography>
      <Button variant="plain" sx={{ mt: '40px' }} onClick={handleClick} disabled={!isButtonEnabled}>
        {t('claim.prove.link.no_link')}
      </Button>
      {/* REMOVE */}
      {instantLinkAuthURL && (
        <>
          <div style={{ flexGrow: 1 }} />
          <Stack alignItems="center" spacing={2} px="31px">
            <Typography>FAKE SMS</Typography>
            <Link sx={{ wordBreak: 'break-word' }} href={instantLinkAuthURL}>
              {instantLinkAuthURL}
            </Link>
          </Stack>
        </>
      )}
      {/* REMOVE */}
    </ViewBase>
  );
}

export default withTranslation()(View);
